// extracted by mini-css-extract-plugin
module.exports = {"sideWrapper":"Navigation_sideWrapper__m9Xiw","isOnSide":"Navigation_isOnSide__JLLz8","sideItem":"Navigation_sideItem__3nZuv","sideLink":"Navigation_sideLink__3QNIT"};